import React from "react"
import { Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"

const ControlView = ({ vistaActual, cambiarVista }) => {
  return (
    <Nav tabs className="nav-tabs-custom nav-justified">
      <NavItem>
        <NavLink
          style={{ cursor: "pointer" }}
          className={classnames({
            active: vistaActual === "formulario",
          })}
          onClick={() => cambiarVista("formulario")}
        >
          <span className="d-block d-sm-none">
            <i className="fas fa-home"></i>
          </span>
          <span className="d-none d-sm-block">Gastos</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          style={{ cursor: "pointer" }}
          className={classnames({
            active: vistaActual === "consulta",
          })}
          onClick={() => cambiarVista("consulta")}
        >
          <span className="d-block d-sm-none">
            <i className="far fa-user"></i>
          </span>
          <span className="d-none d-sm-block">Consulta de Gastos</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          style={{ cursor: "pointer" }}
          className={classnames({
            active: vistaActual === "transferencia",
          })}
          onClick={() => cambiarVista("transferencias")}
        >
          <span className="d-block d-sm-none">
            <i className="far fa-user"></i>
          </span>
          <span className="d-none d-sm-block">Transferencias</span>
        </NavLink>
      </NavItem>
    </Nav>

    // <ButtonGroup className="mb-3">
    //   <Button
    //     color={vistaActual === "formulario" ? "primary" : "secondary"}
    //     onClick={() => cambiarVista("formulario")}
    //   >
    //     Capturar Gastos
    //   </Button>

    //   <Button
    //     color={vistaActual === "consulta" ? "primary" : "secondary"}
    //     onClick={() => cambiarVista("consulta")}
    //   >
    //     Consultar Gastos
    //   </Button>

    //   <Button
    //     color={vistaActual === "transferencias" ? "primary" : "secondary"}
    //     onClick={() => cambiarVista("transferencias")}
    //   >
    //     Transferencias
    //   </Button>
    // </ButtonGroup>
  )
}

export default ControlView
